<template>
  <div class="docs common-main">
    <div class="docs-header">
      <h3>
        {{ $t('docs_welcome') }}（<span>{{ $t('docs_manage_title') }}</span
        >）
      </h3>
      <a-button
        type="default"
        @click="
          () => {
            this.$router.push({ name: 'DocsHome' });
          }
        "
      >
        {{ $t('docs_return_list') }}
      </a-button>
    </div>

    <!-- 搜索 -->
    <div class="docs-list-search">
      <div class="docs-list-search-left">
        <a-form-model :model="form" ref="formElement" class="docs-list-search-form">
          <!-- 关键字 -->
          <a-form-model-item
            :label="null"
            prop="keyword"
            class="docs-list-search-form-keyword"
            style="margin-bottom: 0;"
          >
            <a-input-search
              :placeholder="$t('docs_search_placeholder')"
              v-model="form.keyword"
              allowClear
              @search="onSearch"
            >
            </a-input-search>
          </a-form-model-item>

          <!-- 分类 -->
          <a-form-model-item :label="null" prop="wcId" style="margin-bottom: 0;min-width:150px;">
            <a-select
              v-model="form.wcId"
              :placeholder="$t('docs_search_category_placeholder')"
              allowClear
              v-if="categoryList && categoryList.length > 0"
              @change="onSearch"
            >
              <a-select-option :value="item.id" v-for="item in categoryList" :key="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <!-- 文档状态 -->
          <a-form-model-item :label="null" prop="enable" style="margin-bottom: 0;">
            <a-select
              v-model="form.enable"
              :placeholder="$t('docs_search_status_placeholder')"
              allowClear
              @change="onSearch"
            >
              <a-select-option value="true">
                {{ $t('docs_status_enable') }}
              </a-select-option>
              <a-select-option value="false">
                {{ $t('docs_status_disable') }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form-model>
      </div>
      <div class="docs-list-search-right">
        <a-button type="primary" @click="onSearch">
          {{ $t('com_btn_lookfor') }}
        </a-button>
        <a-button type="default" @click="resetSearch">
          {{ $t('com_btn_reset') }}
        </a-button>
      </div>
    </div>

    <div class="docs-list">
      <div class="docs-list-title">
        <!-- 添加文档 -->
        <router-link
          :to="{
            name: 'DocsPropsAdd',
          }"
          v-if="AUTH_DOCS_ADD"
        >
          <a-button type="primary">
            {{ $t('com_btn_new') }}
          </a-button>
        </router-link>

        <!-- 分类管理 -->
        <router-link
          :to="{
            name: 'DocsCategory',
          }"
          v-if="AUTH_DOCS_CATEGORY_MANAGE"
        >
          <a-button type="default">
            {{ $t('docs_category_manage_title') }}
          </a-button>
        </router-link>
      </div>
      <div class="docs-list-content">
        <!-- 列表 -->
        <a-table
          :columns="columns"
          :data-source="list"
          :rowKey="(text, index) => index"
          bordered
          :pagination="false"
          style="width:100%;"
          :loading="loading"
          @change="handleTableChange"
        >
          <!-- 名称 -->
          <template slot="name" slot-scope="text, record">
            <router-link
              :to="{
                name: 'DocsProps',
                params: { id: record.id },
              }"
              v-if="AUTH_DOCS_DETAIL"
            >
              {{ text }}
            </router-link>
            <span v-else>{{ text }}</span>
          </template>

          <!-- 状态 -->
          <template slot="enable" slot-scope="text">
            <DocsStatus :status="text" />
          </template>

          <!-- 创建时间 -->
          <template slot="createTime" slot-scope="text">
            {{ text | formatDate }}
          </template>

          <!-- 操作 -->
          <template slot="Operation" slot-scope="text, record">
            <DocsOperation
              :record="record"
              :toggle="{
                edit: true,
                delete: true,
                share: true,
                enable: true,
                disable: true,
                back: false,
                props: true,
              }"
              :isList="true"
              @callback="getPageList"
            />
          </template>
        </a-table>
      </div>
      <div class="pagination">
        <Pagination
          :current.sync="pagination.current"
          :total="pagination.total"
          :pageSize.sync="pagination.pageSize"
          :callback="pageChange"
          @change="pageChange"
          :showSizeChanger="true"
        />
      </div>
    </div>
  </div>
</template>
<script>
import DocsStatus from '@/views/docs/components/DocStatus';
import DocsOperation from '@/views/docs/components/Operation';
import * as DocsAPI from '@/api/docs';
import { mapState } from 'vuex';
import docsAuth from '@/views/docs/mixins/docsAuth';
import { trim } from '@/libs/utils';
import { v4 as uuidv4 } from 'uuid';

export default {
  mixins: [docsAuth],
  components: {
    DocsStatus,
    DocsOperation,
  },
  name: 'Docs',
  data() {
    return {
      categoryList: null,
      form: {
        keyword: undefined,
        wcId: undefined,
        enable: undefined,
        orderType: 1,
        orderField: 1,
      },

      list: null,
      // 列表
      columns: [
        {
          title: this.$t('com_table_index'),
          customRender: (text, record, index) =>
            `${index + 1 + (this.pagination.current - 1) * this.pagination.pageSize}`,
          align: 'center',
          width: 60,
        },

        {
          title: this.$t('docs_form_category'),
          dataIndex: 'wikiCategoryName',
        },

        {
          title: this.$t('docs_form_name'),
          dataIndex: 'title',
          scopedSlots: { customRender: 'name' },
        },

        {
          title: this.$t('docs_detail_base_status'),
          dataIndex: 'enable',
          scopedSlots: { customRender: 'enable' },
        },

        {
          title: this.$t('docs_form_auth_read'),
          dataIndex: 'readLevel',
        },

        {
          title: this.$t('docs_form_auth_write'),
          dataIndex: 'writeLevel',
        },

        {
          title: this.$t('docs_detail_base_createBy'),

          dataIndex: 'createBy',
        },
        {
          title: this.$t('docs_detail_base_createTime'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          sorter: true,
        },
        {
          title: this.$t('site_table_operation'),
          align: 'center',
          scopedSlots: { customRender: 'Operation' },
          width: 120,
        },
      ],

      // 分页
      pagination: {
        // 当前页码
        current: 1,
        // 每页显示
        pageSize: 10,
        // 记录总条数
        total: 0,
      },

      loading: false,
    };
  },
  created() {
    // keyword
    if (this.$route.query.keyword) {
      this.form.keyword = this.$route.query.keyword;
    }

    // wcId
    if (this.$route.query.wcId) {
      this.form.wcId = parseInt(this.$route.query.wcId, 10);
    }

    // enable
    if (this.$route.query.enable) {
      this.form.enable = this.$route.query.enable;
    }

    // orderType
    if (this.$route.query.orderType) {
      this.form.orderType = parseInt(this.$route.query.orderType, 10);
    }

    // orderField
    if (this.$route.query.orderField) {
      this.form.orderField = parseInt(this.$route.query.orderField, 10);
    }

    // pageNo
    if (this.$route.query.pageNo) {
      this.pagination.current = parseInt(this.$route.query.pageNo, 10);
    }

    // pageSize
    if (this.$route.query.pageSize) {
      this.pagination.pageSize = parseInt(this.$route.query.pageSize, 10);
    }

    this.getAllDocuments();
    this.getPageList();
  },
  computed: {
    ...mapState(['userInfo']),
  },
  methods: {
    // 搜索
    onSearch() {
      this.pagination.current = 1;
      // this.getPageList();
      this.reloadListPage();
    },

    // 获取分类列表
    getAllDocuments() {
      return DocsAPI.getAllCategories()
        .then(res => {
          if (res.code === 0 && res.data) {
            this.categoryList = res.data || [];
          }
        })
        .catch(() => {
          this.categoryList = null;
        });
    },

    // 调用第一页
    getPageList() {
      const params = {
        keyword: trim(this.form.keyword),
        wcId: this.form.wcId,
        enable: this.form.enable,
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
        orderType: this.form.orderType,
        orderField: this.form.orderField,
      };
      // enable 如果未选择，则不传递
      if (this.form.enable === undefined) {
        delete params.enable;
      }

      this.loading = true;
      return DocsAPI.getDocumentPage(params)
        .then(res => {
          if (res.code === 0 && res.data) {
            this.list = res.data || [];
            this.pagination.total = res.totalCount || 0;
          }
        })
        .finally(() => {
          this.loading = false;
          this.$store.commit('setPageLoading', false);
        });
    },

    // 分页
    pageChange(value) {
      this.pagination.current = value;

      this.reloadListPage();
      // this.getPageList();
    },

    // 重置搜索表单
    resetSearch() {
      // if (
      //   this.form.enable !== undefined ||
      //   this.form.wcId !== undefined ||
      //   this.form.keyword !== ''
      // ) {
      //   this.form = {
      //     keyword: '',
      //     wcId: undefined,
      //     enable: undefined,
      //   };
      // }
      // this.pagination.current = 1;
      // this.getPageList();
      this.$router.replace({
        key: uuidv4(),
        name: 'DocsList',
        query: {},
      });
    },

    handleTableChange(page, filters, sorter) {
      // 排序字段，0表示默认按主键，1按创建时间，2按文档分类，3按文档名，4按文档状态
      if (sorter && sorter.order) {
        if (sorter.order === 'descend') {
          // 倒序
          this.form.orderField = 1;
          this.form.orderType = 1;
        } else {
          // 正序
          this.form.orderField = 1;
          this.form.orderType = 0;
        }
      } else {
        // 创建时间
        this.form.orderField = 1;
        this.form.orderType = 1;
      }

      this.getPageList();
    },

    // 重新跳转页面，在URL记录当前参数
    reloadListPage() {
      this.$router.push({
        key: uuidv4(),
        name: 'DocsList',
        query: {
          ...this.form,
          pageNo: this.pagination.current,
          pageSize: this.pagination.pageSize,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.docs {
  background: @g-layout-background;
  overflow-y: auto;
  border-radius: 12px;
  height: 100%;
  .docs-header {
    padding: 24px;
    border-radius: 12px;
    background: #fff;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    h3 {
      color: #18181a;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      margin: 0;
      span {
        color: #1838d9;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
      }
    }
  }

  .docs-list-search {
    background: #fff;
    padding: 24px;
    border-radius: 12px;
    display: flex;
    margin-bottom: 16px;

    .docs-list-search-left {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      gap: 24px;

      .docs-list-search-form {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        gap: 12px;

        .docs-list-search-form-keyword {
          min-width: 300px;
        }
      }
    }

    .docs-list-search-right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex: 1;
      gap: 24px;
    }
  }

  .docs-list {
    background: #fff;
    padding: 16px 24px 8px 24px;
    border-radius: 12px;
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: calc(100% - 200px);
    height: auto;
    .docs-list-title {
      color: #18181a;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 16px;
    }

    .docs-list-content {
      display: flex;
      padding: 24px 0;
      flex-direction: column;
      align-items: flex-start;
      gap: 24px;
      flex: 1 0 0;
      align-self: stretch;
    }
  }
}
</style>
